import { render } from "./EmployeeUnprocessedRequests.vue?vue&type=template&id=52a380c5"
import script from "./EmployeeUnprocessedRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeUnprocessedRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__